<template>
  <div class="excursion-history" v-if="historyDisplayed">
    <hr class="mt-4 hr" />
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-title id="excursion-history--expansion--header">
          History
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <template v-for="(item, index) in historyItems" :key="index">
            <v-row>
              <v-col>
                <div class="user-display-name">{{ item['audit-metadata'].userDisplayName }}</div>
                <div class="detail-line">{{ item['event-type'] }} | {{ item.metadata.status }}</div>
              </v-col>
              <v-col cols="auto" class="list-action-created-date">
                {{ item.timestamp }}
              </v-col>
            </v-row>
          </template>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';

export default {
  computed: {
    historyDisplayed() {
      return (
        this.$store.state.common.excursionHistoryDisplayed &&
        this.$store.state.common.excursionDc.id > 0 &&
        this.$store.state.common.excursionDc.auditList &&
        this.$store.state.common.excursionDc.auditList.length > 0
      );
    },
    historyItems() {
      return this.$store.state.common.excursionDc.auditList;
    }
  },
  async mounted() {
    if (this.$store.state.common.excursionDc.id > 0) {
      const argHash = {
        id: this.$store.state.common.excursionDc.id,
        query: this.$route.query,
        store: this.$store
      };
      const cbResponse = await this.$app.stbApiAdapter.getAuditExcursions(argHash);
      if (!cbResponse.error) {
        this.$store.commit(types.COMMON_SET_EXCURSION_AUDIT_LIST, cbResponse);
      }
    }
  }
};
</script>
<style scoped>
.excursion-history {
  width: 100%;
}

.excursion-history .theme--light.v-expansion-panel .v-expansion-panel__container {
  background: inherit;
}

.excursion-history .theme--light.v-list {
  background: inherit;
}

.excursion-history .list-action-created-date {
  margin-top: 0px;
  font-size: 9pt;
}

.excursion-history .hr {
  margin-bottom: 0px;
}

.excursion-history .v-expansion-panel {
  box-shadow: none;
  margin-bottom: 0px;
}

.excursion-history .detail-line {
  text-transform: capitalize;
  opacity: 0.6;
}

.excursion-history .user-display-name {
  font-size: 16px;
}
</style>
